import { useCallback, useEffect, useState } from "react";
import styles from "./NewCustomColorPicker.module.css";
import { ColorPicker, Popover, TextField } from "@shopify/polaris";
import { Color } from "../../utilities/parsers";
import { hexToHsba, hsbaToHex } from "../../apps/utilities";
import ShopifyNativeError from "../ShopifyNativeError/ShopifyNativeError";

type Props_CustomColorPicker = {
    setHexColor: (arg: string) => void;
    hexColor: string;
    label: string;
    disabled?: boolean;
    placeholder?: string;
    props: any;
};

const NewCustomColorPicker = ({ hexColor, setHexColor, label, disabled, props }: Props_CustomColorPicker) => {
    const [color, setColor] = useState<Color>(hexToHsba(hexColor));
    const [colorOpacity, setColorOpacity] = useState(() => {
        const { alpha } = hexToHsba(hexColor);
        return alpha;
    });
    const [popoverActive, setPopoverActive] = useState<boolean>(false);
    const togglePopoverActive = useCallback(() => setPopoverActive((active) => !active), []);

    const handleColorChange = (newColor: Color) => {
        setColor(newColor);
        setColorOpacity(newColor.alpha);
        const { hue, saturation, brightness, alpha } = newColor;
        const hex = hsbaToHex(hue, saturation * 100, brightness * 100, alpha);
        setHexColor(hex);
    };

    useEffect(() => {
        if (hexColor) {
            const hsba = hexToHsba(hexColor);
            setColor(hsba);
            setColorOpacity(hsba.alpha);
        }
    }, [hexColor]);

    return (
        <div>
            <Popover
                active={popoverActive && !disabled}
                preferredAlignment="left"
                activator={
                    <div
                        onClick={() => {
                            if (disabled) return;
                            togglePopoverActive();
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "flex-start",
                                flexDirection: "column",
                                gap: "7px",
                                fontWeight: "500",
                                cursor: disabled ? "not-allowed" : "pointer",
                                fontSize: "13px",
                                opacity: disabled ? 0.6 : 1,
                            }}
                        >
                            <span>{label}</span>
                            <div
                                className={`${styles.newCustomColorPickerValueWrapper}
                            `}
                            >
                                <span
                                    style={{
                                        // @ts-expect-error required
                                        "--hexColor": disabled ? "#dbdbdb" : hexColor,
                                    }}
                                    className={`${styles.newCustomColorPickerColor}`}
                                ></span>
                                <span
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        minWidth: 80,
                                        paddingRight: 4,
                                        flexGrow: 1,
                                        paddingLeft: 54,
                                    }}
                                    className={styles.newCustomColorPickerHex}
                                >
                                    {hexColor}
                                </span>
                            </div>
                        </div>
                    </div>
                }
                onClose={togglePopoverActive}
            >
                <div
                    style={{
                        backgroundColor: "#ffffff",
                        padding: "12px",
                        borderRadius: "8px",
                        zIndex: 10,
                        border: "1px solid lightgray",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "250px",
                    }}
                >
                    <ColorPicker onChange={handleColorChange} color={color} allowAlpha />
                    <div
                        style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                        }}
                    >
                        <TextField
                            label=""
                            autoComplete="off"
                            placeholder="#ffffff"
                            maxLength={9}
                            value={hexColor}
                            size="slim"
                            disabled={disabled}
                            onChange={(val) => {
                                setHexColor(val);
                                if ((val.length == 7 || val.length == 9) && val.startsWith("#")) {
                                    const hsbaColor = hexToHsba(val);
                                    handleColorChange(hsbaColor);
                                }
                            }}
                            onBlur={props?.onBlur}
                        />

                        <TextField
                            label=""
                            autoComplete="off"
                            placeholder="#ffffff"
                            maxLength={3}
                            value={Math.round(colorOpacity * 100).toString()}
                            suffix={"%"}
                            max={100}
                            min={0}
                            size="slim"
                            disabled={disabled}
                            onChange={(val) => {
                                const numRegex = /^\d+$/;
                                if (!numRegex.test(val)) {
                                    val = "0";
                                }
                                if (+val > 100) {
                                    val = "100";
                                }

                                console._log("VALLLL", val);
                                const posVal = +val / 100;
                                const { hue, saturation, brightness } = hexToHsba(hexColor);
                                setColorOpacity(posVal);
                                handleColorChange({ hue, saturation, brightness, alpha: posVal });
                            }}
                            onBlur={props?.onBlur}
                        />
                    </div>
                </div>
            </Popover>
            {!!props?.error?.length && <ShopifyNativeError error={props?.error} key={label} style={{ marginTop: 4 }} />}
        </div>
    );
};

export default NewCustomColorPicker;
